import type { ImportContentPayload } from '@metapic-apps/shared'

export const resolveInstagramContentType = (
  value: string | undefined,
): ImportContentPayload['contentType'] | null => {
  const trimmedValue = value?.trim()
  if (!trimmedValue) {
    return null
  }

  try {
    const urlObj = new URL(trimmedValue)
    const { hostname } = urlObj
    if (hostname !== 'instagram.com' && !hostname.endsWith('.instagram.com')) {
      return null
    }
    const segments = urlObj.pathname.split('/').filter(Boolean)
    if (segments.includes('reel') || segments.includes('reels')) {
      return 'instagram_reel'
    }
    if (segments.includes('p')) {
      return 'instagram_post'
    }
    return null
  } catch {
    return null
  }
}
